import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import {
	ButtonGroup,
	DialogContent,
	DialogContentText,
	Grid,
} from '@mui/material';
import { useEmployeeContext } from '../context/PuzzelContext';

const ratings = Array.from({ length: 11 }, (_, i) => String(i));

export default function PGapDialog() {
	const {
		puzzelState,
		campaignMemberModel,
		shouldHavePGap,
		setShouldHavePGap,
		setPuzzelState,
		setCampaignMemberModel,
	} = useEmployeeContext();

	const handleListItemClick = (value: string) => {
		setShouldHavePGap(false);
		const valueNumber = Number(value);
		setPuzzelState({
			...puzzelState,
			agentRating: valueNumber
		});
		setCampaignMemberModel({
			...campaignMemberModel,
			agentRating: valueNumber
		});
	};

	return (
		<Dialog
			aria-labelledby="simple-dialog-title"
			open={shouldHavePGap}
			maxWidth={'xl'}
		>
			<DialogTitle id="simple-dialog-title">P-gap</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Based on your recent interaction on this case, how satisfied do
					you think the customer is?
				</DialogContentText>
			</DialogContent>
			<ButtonGroup
				variant="contained"
				color="secondary"
				aria-label="outlined secondary button group"
				size="large"
				fullWidth={true}
			>
				{ratings.map((rating, key) => (
					<Button key={key} onClick={() => handleListItemClick(rating)}>
						{rating}
					</Button>
				))}
			</ButtonGroup>
			<Grid
				container
				direction="row"
				justifyContent="space-between"
				alignItems="center"
			>
				<Typography variant="h6">
					Not satisfied
				</Typography>
				<Typography variant="h6">
					Very satisfied
				</Typography>
			</Grid>
		</Dialog>
	);
}
